import { EMPTY, NEVER } from "rxjs";
import { filter, switchMapTo, takeUntil } from "rxjs/operators";
import { pathHandleCoopInvitePlayerError } from "../cooperative/path/pathHandleCoopInvitePlayerError";
import { guard } from "../guards/guard";
import { pathHandleDisconnectedByLogin } from "../reconnect-after-login/pathHandleDisconnectedByLogin";
import { checkForCoopInvitePlayerError } from "./checkForCoopInvitePlayerError";
import { checkForDisconnectedByLoginError } from "./checkForDisconnectedByLoginError";
import { checkForFbConnectError } from "./checkForFbConnectError";
import { checkForJoinCoopError } from "./checkForJoinCoopError";
import { checkForTextError } from "./checkForTextError";
import { pathErrorDefault } from "./path/pathErrorDefault";
import { pathHandleTextError } from "./path/pathHandleTextError";
export var createEpicError = function (idNetwork, triggerActionFilter, StatusCode, sourceSelector, stopEpic) {
    if (stopEpic === void 0) { stopEpic = function () { return NEVER; }; }
    return function (action$, state$, deps) {
        return action$.pipe(filter(triggerActionFilter), switchMapTo(sourceSelector(deps)), filter(function (response) { return response.statusCode !== StatusCode.OK; }), takeUntil(stopEpic(action$, state$, deps)), guard(state$, deps, pathErrorDefault(idNetwork))([
            checkForTextError(pathHandleTextError),
            checkForDisconnectedByLoginError(pathHandleDisconnectedByLogin),
            checkForFbConnectError(function () { return EMPTY; }),
            checkForJoinCoopError(function () { return EMPTY; }),
            checkForCoopInvitePlayerError(pathHandleCoopInvitePlayerError),
        ]));
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/createEpicError.ts
// module id = 1842
// module chunks = 3